<template>
  <div class="scorecard q-pa-md" v-if="hasData">
    <q-markup-table separator="cell" flat bordered dense>
      <thead>
        <q-th colspan="2"></q-th>
        <q-th colspan="3">Men</q-th>
        <q-th colspan="3">Women</q-th>
        <q-th colspan="1"></q-th>
        <tr>
          <th>Tee</th>
          <th>Length</th>
          <th>Par</th>
          <th>Rating</th>
          <th>Slope</th>
          <th>Par</th>
          <th>Rating</th>
          <th>Slope</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Back</td>
          <td>{{ course.OLGDP142_formatted }}</td>
          <td>{{ course.OLGDP139 }}</td>
          <td>{{ course.OLGDP140 }}</td>
          <td>{{ course.OLGDP141 }}</td>
          <td>{{ course.OLGDP114 }}</td>
          <td>{{ course.OLGDP115 }}</td>
          <td>{{ course.OLGDP116 }}</td>
          <td>{{ course.OLGDP117 }}</td>
        </tr>
        <tr>
          <td>Middle</td>
          <td>{{ course.OLGDP118_formatted }}</td>
          <td>{{ course.OLGDP119 }}</td>
          <td>{{ course.OLGDP121 }}</td>
          <td>{{ course.OLGDP123 }}</td>
          <td>{{ course.OLGDP120 }}</td>
          <td>{{ course.OLGDP122 }}</td>
          <td>{{ course.OLGDP124 }}</td>
          <td>{{ course.OLGDP125 }}</td>
        </tr>
        <tr>
          <td>Forward</td>
          <td>{{ course.OLGDP126_formatted }}</td>
          <td>{{ course.OLGDP127 }}</td>
          <td>{{ course.OLGDP129 }}</td>
          <td>{{ course.OLGDP131 }}</td>
          <td>{{ course.OLGDP128 }}</td>
          <td>{{ course.OLGDP130 }}</td>
          <td>{{ course.OLGDP132 }}</td>
          <td>{{ course.OLGDP133 }}</td>
        </tr>
      </tbody>
    </q-markup-table>
  </div>
  <div class="q-pa-md" v-else>
    There is no scorecard available for this course yet. If you have scorecard
    info please suggest a course update
    <a href="https://forms.gle/YrSqGwJuPrgodbV68" target="_blank" rel="noopener"
      >here</a
    >. Thanks!
  </div>
</template>
<script>
export default {
  name: "Scorecard",
  props: {
    course: {
      required: true,
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    hasData() {
      return [
        "OLGDP114",
        "OLGDP115",
        "OLGDP116",
        "OLGDP117",
        "OLGDP118",
        "OLGDP119",
        "OLGDP120",
        "OLGDP121",
        "OLGDP122",
        "OLGDP123",
        "OLGDP124",
        "OLGDP125",
        "OLGDP126",
        "OLGDP127",
        "OLGDP128",
        "OLGDP129",
        "OLGDP130",
        "OLGDP131",
        "OLGDP132",
        "OLGDP133",
        "OLGDP139",
        "OLGDP140",
        "OLGDP141",
        "OLGDP142",
      ].some(id => Boolean(this.course[id]));
    },
  },
};
</script>
<style lang="scss" scoped>
.scorecard {
  min-width: 310px;
  max-width: 1000px;
}

.q-table {
  th {
    font-weight: bold;
  }

  th,
  td {
    text-align: center;

    &:first-child {
      text-align: left;
    }
  }
}
</style>
